import { useCarousel, UseCarouselReturn } from "@/hooks/useCarousel";
import { featuresContent } from "@/data/landingpage";

export const useFeatures = (): UseCarouselReturn => {
  return useCarousel({
    containerId: "carousel",
    totalItems: featuresContent.features.length,
    autoScrollInterval: 5000,
    isMobile: false, // Features uses desktop-style scrolling
  });
};
